import React from 'react';
import { createComponent } from '@lit/react';
import { IxButton as IxButtonLit } from '../IxButton.js';

customElements.define('ix-button', IxButtonLit);

export const IxButton = createComponent({
  tagName: 'ix-button-react',
  elementClass: IxButtonLit,
  react: React,
});
